import wsScheduled from '@/services/events_scheduled_sends'
import dashboardBundleService from '@/services/dashboard/event_dashboard_bundle'
import useMessageTypeLabel from '@/composables/useMessageTypeLabel'

const { getMessageTypeLabel } = useMessageTypeLabel()

function normalizeDateTime(dateValue, timeValue) {
  if (!dateValue) return null

  const datePart = String(dateValue).substring(0, 10)
  const timePart = timeValue ? String(timeValue).substring(0, 8) : '00:00:00'
  const parsed = new Date(`${datePart}T${timePart}`)
  return Number.isNaN(parsed.getTime()) ? null : parsed
}

function formatDate(dateValue) {
  if (!dateValue) return ''
  const raw = String(dateValue).substring(0, 10)
  const parsed = new Date(`${raw}T00:00:00`)

  if (Number.isNaN(parsed.getTime())) {
    return raw
  }

  const dd = `${parsed.getDate()}`.padStart(2, '0')
  const mm = `${parsed.getMonth() + 1}`.padStart(2, '0')
  const yyyy = parsed.getFullYear()
  return `${dd}/${mm}/${yyyy}`
}

function formatTime(timeValue) {
  if (!timeValue) return ''
  return String(timeValue).substring(0, 5)
}

function getStatusLabel(status) {
  switch ((status || '').toLowerCase()) {
    case 'scheduled': return 'Programado'
    case 'executing': return 'Ejecutando'
    case 'queued': return 'En cola'
    case 'executed': return 'Ejecutado'
    case 'cancelled': return 'Cancelado'
    case 'failed': return 'Error'
    default: return status || '-'
  }
}

function pickNextScheduled(items) {
  const candidates = (items || []).filter(item => ['scheduled', 'queued', 'executing', 'failed'].includes((item.status || '').toLowerCase()))

  if (!candidates.length) {
    return null
  }

  return candidates
    .slice()
    .sort((a, b) => {
      const aDate = normalizeDateTime(a.scheduled_date, a.scheduled_time)
      const bDate = normalizeDateTime(b.scheduled_date, b.scheduled_time)

      if (!aDate && !bDate) return 0
      if (!aDate) return 1
      if (!bDate) return -1
      return aDate.getTime() - bDate.getTime()
    })[0]
}

export default {
  async get(eventId, options = {}) {
    if (!eventId) {
      return { exists: false }
    }

    try {
      const bundle = await dashboardBundleService.get(eventId, options)
      const items = bundle.schedules || []
      const next = pickNextScheduled(items)

      if (!next) {
        return { exists: false }
      }

      return {
        exists: true,
        id: next.id,
        raw: next,
        type: next.message_type,
        typeLabel: getMessageTypeLabel(next.message_type),
        status: next.status,
        statusLabel: getStatusLabel(next.status),
        recipientCount: Number(next.recipient_count || 0),
        date: formatDate(next.scheduled_date),
        time: formatTime(next.scheduled_time)
      }
    } catch (error) {
      return { exists: false }
    }
  },

  async cancel(eventId, scheduleId) {
    const response = await wsScheduled.cancel(eventId, scheduleId)
    dashboardBundleService.invalidate(eventId)
    return response
  },

  async executeNow(eventId, scheduleId) {
    const response = await wsScheduled.executeNow(eventId, scheduleId)
    dashboardBundleService.invalidate(eventId)
    return response
  },

  invalidate(eventId) {
    dashboardBundleService.invalidate(eventId)
  }
}
